import React, { useMemo } from 'react';

import { RoofContainer } from '@paragon/contract-library';
import { createRoofBasePolygons } from '@paragon/layout';

import { useRoofElevation } from '../../../../store/selectors/layoutDocumentSelectors';
import { AutomaticRunDimensions } from '../AutomaticRunDimensions';
import { useTrussEnvelopesWithInsertionEnvelope } from '../useTrussEnvelopesWithInsertionEnvelope';

export function SingleRoofContainerRunDimensionsController(props: { roofContainer: RoofContainer }) {
  const elevation = useRoofElevation(props.roofContainer.guid) ?? 0;
  const roofBase = useMemo(() => createRoofBasePolygons(props.roofContainer), [props.roofContainer]);

  const trussEnvelopesWithInsertionEnvelope = useTrussEnvelopesWithInsertionEnvelope(props.roofContainer.guid);

  return roofBase.map((area, index) => (
    <AutomaticRunDimensions
      key={index}
      elevation={elevation}
      dimensionedArea={area}
      trussEnvelopes={trussEnvelopesWithInsertionEnvelope}
    />
  ));
}
